import { render, staticRenderFns } from "./EditPlanChargesModal.vue?vue&type=template&id=a38563da&"
import script from "./EditPlanChargesModal.vue?vue&type=script&lang=ts&"
export * from "./EditPlanChargesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports